import React from 'react'
import InvitationListDataTable from '../../components/Admin/InvitationList';

const InvitationList = () => {
  return (
    <InvitationListDataTable />
  )
}

export default InvitationList;